import { Checkbox, Empty, Input, Skeleton, Space } from "antd";
import { FontAwesomeIcon, Icon } from "assets/icons";
import MenuLayout from "components/CustomFilterMenu/MenuLayout";
import useDebounce from "hooks/useDebounce";
import { useGetSellerLoadMore } from "hooks/seller";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";

const MENU_LAYOUT = {
  width: "300px",
};

const SPACE_LAYOUT = {
  width: "100%",
  maxHeight: "200px",
  overflow: "auto",
  paddingBottom: "2px",
};

const FilterSellerContract = ({ onFilter, defaultValue }) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [searchValue, setSearchValue] = useState("");
  const searchDebounce = useDebounce(searchValue, 500);

  const [params, setParams] = useState({
    filters: { query: undefined },
    pagination: { offset: 0, limit: 10 },
  });

  const { sellersList, loading, hasMoreData, loadMoreDataSellers } = useGetSellerLoadMore(params, "cache-first");

  useEffect(() => {
    setParams({
      filters: { query: searchDebounce?.trim() || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  }, [searchDebounce]);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const handleResetFilter = () => {
    setSelectedValue(undefined);
    setSearchValue("");
  };

  const handleApplyFilter = () => {
    onFilter && onFilter(selectedValue);
  };

  const handleToggle = (id) => {
    setSelectedValue((prev) => (prev === id ? undefined : id));
  };

  return (
    <MenuLayout
      style={MENU_LAYOUT}
      applyFilter={handleApplyFilter}
      resetFilter={handleResetFilter}
      filterContent={
        <>
          <Input
            prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
            placeholder={t("common.search")}
            allowClear={true}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          {!loading && !sellersList?.length && <Empty />}
          {sellersList?.length > 0 && (
            <InfiniteScroll
              dataLength={sellersList?.length || 0}
              next={loadMoreDataSellers}
              hasMore={hasMoreData}
              style={SPACE_LAYOUT}
              height={200}
              loader={<Skeleton paragraph={{ rows: 1 }} active />}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                {sellersList.map((item) => (
                  <Checkbox key={item?.id} checked={selectedValue === item?.id} onChange={() => handleToggle(item?.id)}>
                    {item?.fullName} {item?.code ? `(${item.code})` : ""}
                  </Checkbox>
                ))}
              </Space>
            </InfiniteScroll>
          )}
        </>
      }
    />
  );
};

export default FilterSellerContract;
